import DateTimeHelper from 'infrastructure/js/utils/dateTimeHelper';
import {createLabelHelper} from 'infrastructure/js/utils/labelHelper';

const getHumanCapacityString = (humanCapacity, shiftHumanCapacity, isPureHTML) => {
  const shiftsOutOfWorkers = createLabelHelper('')?.get('shifts.outOfWorkers', '' ,{humanCapacity, shiftHumanCapacity});
  return `${isPureHTML ? '<br/>' : ''}${shiftsOutOfWorkers}`;
};

export function formatShiftSegment(segmentData, isPureHTML) {
  const {
    plannedStartDateSegment,
    plannedEndDateSegment,
    humanCapacity = '',
    shiftHumanCapacity = '',
  } = segmentData;

  const startTime = DateTimeHelper.ConvertToDate(plannedStartDateSegment);
  const endTime = DateTimeHelper.ConvertToDate(plannedEndDateSegment);
  const isSameDay = startTime.isSame(endTime, 'day');
  const timeRangeStr = `${startTime.format('HH:mm')}-${endTime.format('HH:mm')}`;

  return `${timeRangeStr}${!isSameDay ? '(+1)' : ''}, ${getHumanCapacityString(
    humanCapacity,
    shiftHumanCapacity,
    isPureHTML
  )}`;
}
